import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Error429Service } from 'src/app/services/error429.service';
import { UserService } from 'src/app/services/user.service';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-clientes',
  templateUrl: './clientes.component.html',
  styleUrls: ['./clientes.component.css']
})
export class ClientesComponent implements OnInit{

  clients: any[] = []; //Información básica los clientes
  datosRecibidos: boolean = false; // Variable para controlar la visibilidad de los datos recibidos
  errorMessage : string =""; //Mensaje de error
  displayedColumns: string[] = ['id', 'razon_social', 'nombre_comercial', 'created_at', 'updated_at', 'status', 'operaciones'];
  dataSource :any;
  clientsData: any [] = []; //Información de los clientes
  tiempoEsperaRecarga: number = 60000; //Despues del error 429 se esperan 60 segundos para recargar la página
  numeroClientes: number = 0;
  pageSizeOptions: number[] = [5, 10, this.numeroClientes];

  //PAGINACIÓN
  currentPage: number = 0;
  currentPageSize: number = 20;
  totalItems: number = 300;
  sizeOptions: number[] = [10, 20, 30];

  private clientsSubscription: Subscription | undefined;

  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private userService: UserService, private router: Router, private error429: Error429Service){}
  
  ngOnInit(): void {
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.clientsData.push({
            id: resp[i].id,
            razon_social: resp[i].razon_social,
            nombre_comercial: resp[i].nombre_comercial,
            created_at: resp[i].created_at,
            updated_at: resp[i].updated_at,
            status: resp[i].status,
          });
        }
        console.log(this.clientsData);
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.dataSource = new MatTableDataSource(this.clientsData); 
        this.datosRecibidos = true; 
        this.numeroClientes = this.clientsData.length;
        if(Math.floor(this.numeroClientes/2)==0){
          this.pageSizeOptions = [this.numeroClientes];
        } else {
          this.pageSizeOptions = [5, Math.floor(this.numeroClientes/2), this.numeroClientes];
        }
        //this.pageSizeOptions = [ Math.floor(this.numeroClientes/2), this.numeroClientes];
        setTimeout(() => {
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        },0)
      }
    });
  }

  ngOnDestroy(): void {
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
  }

  pageChanged(event: any) {
    this.currentPage = event.pageIndex;
    this.currentPageSize = event.pageSize;
  }

  //Función para convertir la fecha
  formatDateTime(dateTimeString: string | null): string {
    if (dateTimeString !== null) {
      const inputDate = new Date(dateTimeString);
      const year = inputDate.getFullYear();
      const month = ('0' + (inputDate.getMonth() + 1)).slice(-2);
      const day = ('0' + inputDate.getDate()).slice(-2);
      const hours = ('0' + inputDate.getHours()).slice(-2);
      const minutes = ('0' + inputDate.getMinutes()).slice(-2);
      const seconds = ('0' + inputDate.getSeconds()).slice(-2);
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
    return '';
  }

  //Funciones para actualizar la página actual despues de un tiempoEsperaRecarga
  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  descargarExcel(){
    console.log(this.clientsData);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    worksheet.columns = [
      { header: 'Código', key: 'codigo', width: 10 },
      { header: 'Razón Social', key: 'razon_social', width: 30 },
      { header: 'Nombre Comercial', key: 'nombre_comercial', width: 30 },
      { header: 'Fecha de alta', key: 'created_at', width: 25 },
      { header: 'Modificado', key: 'updated_at', width: 25 },
      { header: 'Estado', key: 'estado', width: 15 },
    ];
    /*this.devicesAndEstablishmentInfo.forEach(establecimiento => {
      worksheet.addRow(establecimiento);
    });*/
    this.clientsData.forEach(cliente => {
      const formattedCliente = {
        codigo: cliente.id,
        razon_social: cliente.razon_social,
        nombre_comercial: cliente.nombre_comercial,
        created_at: this.formatDateTime(cliente.created_at),
        updated_at: this.formatDateTime(cliente.updated_at),
        estado: cliente.status === 1 ? 'activo' : 'desactivado',
      };
      worksheet.addRow(formattedCliente);
    });
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(blob, 'Listado clientes DataBeer.xlsx');
    });
  }
}
